import { Routes } from '@angular/router';
import { adminGuard } from './core/guards/admin.guard';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';
import { unsavedChangesGuard } from './core/guards/unsaved-changes.guard';
import { ORDER_DOCUMENT_ROLES, DELIVERY_NOTE_ROLES, ORDERS_ROLES } from './shared/constants/role-access';
import { UserRole } from './shared/models/user.model';
import { OrderDocumentsComponent } from './pages/order-documents/order-documents.component';
import { CreateOrderDocumentComponent } from './pages/create-order-document/create-order-document.component';
import { DeliveryDatesComponent } from './pages/delivery-dates/delivery-dates.component';
import { DeliveryDatesOverviewComponent } from './pages/delivery-dates-overview/delivery-dates-overview.component';
import { CreateDeliveryNoteComponent } from './pages/create-delivery-note/create-delivery-note.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { DeliveryNotesComponent } from './pages/delivery-notes/delivery-notes.component';
import { LoginComponent } from './pages/login/login.component';
import { OrdersComponent } from './pages/orders/orders.component';
import { DmsExportComponent } from './pages/settings/dms-export.component';
import { DeliverNoteStatisticsComponent } from './pages/deliver-note-statistics/deliver-note-statistics.component';
import { TextBlocksComponent } from './pages/text-blocks/text-blocks.component';
import { UsersComponent } from './pages/users/users.component';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [authGuard, adminGuard],
  },
  {
    path: 'users',
    component: UsersComponent,
    canActivate: [authGuard, adminGuard],
  },
  {
    path: 'orders',
    component: OrdersComponent,
    canActivate: [authGuard, roleGuard(...ORDERS_ROLES)],
  },
  {
    path: 'order-documents',
    component: OrderDocumentsComponent,
    canActivate: [authGuard, roleGuard(...ORDER_DOCUMENT_ROLES)],
  },
  {
    path: 'order-documents/new',
    component: CreateOrderDocumentComponent,
    canActivate: [authGuard, roleGuard(UserRole.WARENEINGANG)],
    canDeactivate: [unsavedChangesGuard],
  },
  {
    path: 'order-documents/edit/:id',
    component: CreateOrderDocumentComponent,
    canActivate: [authGuard, roleGuard(...ORDER_DOCUMENT_ROLES)],
    canDeactivate: [unsavedChangesGuard],
  },
  {
    path: 'delivery-notes',
    component: DeliveryNotesComponent,
    canActivate: [authGuard, roleGuard(...DELIVERY_NOTE_ROLES)],
  },
  {
    path: 'delivery-notes/new',
    component: CreateDeliveryNoteComponent,
    canActivate: [authGuard, roleGuard(...DELIVERY_NOTE_ROLES)],
  },
  {
    path: 'delivery-notes/edit/:id',
    component: CreateDeliveryNoteComponent,
    canActivate: [authGuard, roleGuard(...DELIVERY_NOTE_ROLES)],
  },
  {
    path: 'deliver-note-statistics',
    component: DeliverNoteStatisticsComponent,
    canActivate: [authGuard, adminGuard],
  },
  {
    path: 'text-blocks',
    component: TextBlocksComponent,
    canActivate: [authGuard, adminGuard],
  },
  {
    path: 'dms-export',
    component: DmsExportComponent,
    canActivate: [authGuard, adminGuard],
  },
  {
    // In-app Liefertermine list (all upcoming dates) — visible to every role, hence authGuard only.
    path: 'delivery-dates',
    component: DeliveryDatesComponent,
    canActivate: [authGuard],
  },
  {
    // Public, read-only production TV board — reachable by URL only (intentionally NOT in the
    // sidebar menu) and open without login so a TV browser can display it directly.
    path: 'delivery-dates-overview',
    component: DeliveryDatesOverviewComponent,
  },
  {
    path: '**',
    redirectTo: '/login',
  },
];
